import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 700px;
  max-width: 100%;
  height: 480px;
`;

export const StepperContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 24px;
  padding: 4px 4px 0;
`;

export const StepButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;

export const StepCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;
  border: 2px solid
    ${(props) =>
      props.status === 'done'
        ? '#22c55e'
        : props.status === 'active'
          ? '#3498ff'
          : '#cbd5e1'};
  background: ${(props) =>
    props.status === 'done'
      ? '#22c55e'
      : props.status === 'active'
        ? '#3498ff'
        : '#ffffff'};
  color: ${(props) => (props.status === 'pending' ? '#94a3b8' : '#ffffff')};

  ${StepButton}:hover:not(:disabled) & {
    border-color: #3498ff;
    ${(props) => props.status === 'pending' && 'color: #3498ff;'}
  }
`;

export const StepLabel = styled.span`
  font-size: 12px;
  font-weight: ${(props) => (props.status === 'active' ? 700 : 500)};
  color: ${(props) => (props.status === 'pending' ? '#94a3b8' : '#334155')};
  white-space: nowrap;

  ${StepButton}:hover:not(:disabled) & {
    color: #3498ff;
  }
`;

export const StepLine = styled.div`
  width: 64px;
  height: 2px;
  flex-shrink: 0;
  margin: 0 8px;
  margin-top: 15px;
  background: ${(props) => (props.filled ? '#22c55e' : '#e2e8f0')};
  transition: background 0.2s ease-in-out;
`;

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  animation: fadeIn 0.3s ease-in-out;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

export const ContainerTab = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  border-radius: 8px;
`;

export const TabTitle = styled.b`
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
  display: block;
`;

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Field = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  margin: 8px 0px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  gap: 15px;
`;

export const SchedulePromo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns:  3fr 2fr 2fr 1fr 1fr;
  margin: 10px 0px;
  background-color: ${({ theme }) => theme?.colors?.backgroundSecondary || '#f4f4f4'};
  padding: 6px 10px;
  border-radius: 6px;
`;

export const SchedulePromoField = styled.div`
    color: ${({ theme }) => theme?.colors?.text || '#333'};
    font-size: 12px;
`;

export const SchedulePromoStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.status ? '#03b252' : '#e33c30'};
  color: #fff;
  border-radius: 6px;
  font-size: 11px;
  padding: 2px 5px;
`

export const IconButtonPromo = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
  padding: 0 6px;
  color: ${({ theme }) => theme?.colors?.text || '#333'};
`;

export const TitleSchedulePromo = styled.span`
  color: ${({ theme }) => theme?.colors?.text || '#333'};
  font-size: 16px;
`;

export const ContainerRules = styled.div``;

export const RulePromo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr 0fr 0fr;
  margin: 10px 0px;
  background-color: ${({ theme }) => theme?.colors?.backgroundSecondary || '#f4f4f4'};
  padding: 8px 10px;
  border-radius: 6px;
`;

export const RulePromoField = styled.div`
  color: ${({ theme }) => theme?.colors?.text || '#333'};
  font-size: 12px;
`;

export const ContainerBenefit = styled.div``

export const BenefitPromo = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 3fr 1fr 1fr 0fr 0fr;
  margin: 10px 0px;
  background-color: ${({ theme }) => theme?.colors?.backgroundSecondary || '#f4f4f4'};
  padding: 8px 10px;
  border-radius: 6px;
`;

export const BenefitPromoField = styled.div`
  color: ${({ theme }) => theme?.colors?.text || '#333'};
  font-size: 12px;
`;

export const TabHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h3 {
    margin: 0;
    font-size: 16px;
    color: #334155;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  color: #64748b;
  text-align: center;
  gap: 12px;
  margin-top: 10px;

  p {
    margin: 0;
    font-size: 14px;
  }
`;

export const ListItemCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 12px 16px;
  border-radius: 10px;
  margin-bottom: 10px;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border-color: #cbd5e1;
  }

  .info-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
  }

  .title {
    font-weight: 600;
    color: #334155;
    font-size: 14px;
  }

  .subtitle {
    font-size: 12px;
    color: #64748b;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  font-size: 12.5px;
  line-height: 1.5;
  margin-bottom: 14px;

  background: ${(props) => (props.variant === 'warning' ? '#fffbeb' : '#eff6ff')};
  border: 1px solid ${(props) => (props.variant === 'warning' ? '#fde68a' : '#bfdbfe')};
  color: ${(props) => (props.variant === 'warning' ? '#92400e' : '#1e40af')};

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }

  b {
    font-weight: 700;
  }
`;

export const Badge = styled.span`
  background: ${(props) => (props.active ? '#dcfce7' : '#fee2e2')};
  color: ${(props) => (props.active ? '#166534' : '#991b1b')};
  padding: 4px 8px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const FooterBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;

  .footer-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .footer-hint {
    font-size: 12px;
    color: #b45309;
  }
`;
